import React from 'react';
import SavedMenus from './SavedMenus';
import { Alert } from '../../../shared/components/ui';
import { useTranslation } from 'react-i18next';

const WeekSection = ({
    title,
    menus,
    menuMetadata,
    onMenuSelect,
    onToggleRepeatable,
    onMenusReordered,
    isLoading = false,
    isCurrentWeek = false
}) => {
    const { t } = useTranslation();

    const formatWeekRange = (menus) => {
        if (!menus || menus.length === 0) return '';

        const dates = menus.map(m => new Date(m.date)).filter(d => !isNaN(d.getTime()));
        if (dates.length === 0) return '';

        const sortedDates = dates.sort((a, b) => a - b);
        const startDate = sortedDates[0];
        const endDate = sortedDates[sortedDates.length - 1];

        return `${startDate.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })} - ${endDate.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' })}`;
    };

    const weekRange = formatWeekRange(menus);

    return (
        <div className="mb-8">
            <div className="mb-4">
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1">
                    {title}
                </h2>
                {weekRange && (
                    <p className="text-sm text-gray-600">
                        {weekRange}
                    </p>
                )}
            </div>

            {isLoading ? (
                <Alert variant="info">
                    <p>{t('plan.loading') || t('common.loading')}</p>
                </Alert>
            ) : menus.length === 0 ? (
                <Alert variant="info">
                    <p>{t('plan.noMenus') || 'No hay menús disponibles para esta semana'}</p>
                </Alert>
            ) : (
                <SavedMenus
                    menus={menus}
                    onMenuSelect={onMenuSelect}
                    isLoading={isLoading}
                    onMenusReordered={onMenusReordered}
                    onToggleRepeatable={onToggleRepeatable}
                    menuMetadata={menuMetadata}
                    isCurrentWeek={isCurrentWeek}
                />
            )}
        </div>
    );
};

export default WeekSection;

